module.exports = __webpack_public_path__ + "img/talent-card.12dd9ef9.svg";